// Services
import exerciseService from '@/app/services/main/exercise/exercise-service.js';

// Third party libraries
import * as $ from 'jquery';
import DatePicker from 'vue2-datepicker';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';

// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util';

// Constants
import { SUCCESS_MSG } from '@/app/constants/status-constants';

export default {
	name: 'ModalAddExercise',
	components: {
		DatePicker
	},
	mixins: [
		toastMessageMixins,
		dateMixins,
		userMixins
	],
	data() {
		return this.initializeModalData();
	},
	computed: {
		validationRules() {
			let fields = {
				exerciseDetails: {
					exerciseDate: {}
				}
			}

			fields.exerciseDetails = vuelidateUtil.setFieldsRequired(fields.exerciseDetails, true);
			fields.exerciseDetails = vuelidateUtil.setIsFutureNextYear(fields.exerciseDetails, 'exerciseDate');
			fields = vuelidateUtil.setRequiredValidation(fields, 'selectedBrand');

			return fields;
		},
		isDisabled() {
			const {offLeash, onLeash} = this.exerciseDetails;
			
			return offLeash || onLeash ? false : true;
		}
	},
	watch: {
		isAddModalLoading(isLoading) {
			if (!isLoading) {
				this.closeModal();
			}
		},
		'exerciseDetails.offLeash': {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					if ( newVal <= 300 ) {
						this.exerciseDetails.offLeash = newVal;
					} else {
						this.exerciseDetails.offLeash = newVal.slice(0, -1);
					}
				}
			},
			deep: true
		},
		'exerciseDetails.onLeash': {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					if ( newVal <= 300 ) {
						this.exerciseDetails.onLeash = newVal;
					} else {
						this.exerciseDetails.onLeash = newVal.slice(0, -1);
					}
				}
			},
			deep: true
		}
	},
	beforeDestroy() {
		this.closeModal();
	},
	methods: {
		initializeModalData() {
			return {
				exerciseDetails: {
					offLeash: '',
					onLeash:'',
					exerciseDate: ''
				},
				dateExist: false
			}
		},
		show() {
			this.clearModalFields();
			$(this.$refs.modalAddExercise).modal('show');
		},
		closeModal() {
			$(this.$refs.modalAddExercise).modal('hide');
		},
		clearModalFields() {
			Object.assign(this.$data, this.initializeModalData());
			this.$v.$reset();
		},
		addExercise() {
			const {exerciseDate, offLeash, onLeash} = this.exerciseDetails;

			const exerciseDetails = {
				exerciseDate: this.dateToISO(exerciseDate)
			};

			if (offLeash) exerciseDetails.offLeash = parseInt(offLeash);

			if (onLeash) exerciseDetails.onLeash = parseInt(onLeash);

			exerciseDetails.petId = this.getActivePet.id;

			exerciseService.postExercise(exerciseDetails)
				.then(res => {

					if(res.status === 204){
						const { SUCCESS_ADDED_EXERCISE } = this.toastMessages.exercise();
						
						this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_ADDED_EXERCISE);
						
						this.closeModal();

						this.$emit('addExercise');
					}else{
						this.dateExist = true;
					}
				})
			
		},
		dateChange() {
			this.dateExist = false;
		},
		checkValue(type) {
			if ( type === "onLeash" ) {
				if ( this.exerciseDetails.onLeash && this.exerciseDetails.onLeash < 5 ) {
					this.exerciseDetails.onLeash = 5;
				}
			} else {
				if ( this.exerciseDetails.offLeash && this.exerciseDetails.offLeash < 5 ) {
					this.exerciseDetails.offLeash = 5;
				}
			}
		}
	},
	validations() {
		return this.validationRules;
	}
} 